__turbopack_context__.v({
  "section": "Section-module__loed3W__section",
  "sectionSpacer": "Section-module__loed3W__sectionSpacer",
  "title": "Section-module__loed3W__title",
  "titleDivider": "Section-module__loed3W__titleDivider",
  "visible": "Section-module__loed3W__visible",
});
